// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"24dfa2f8","667":"376ebba0"}[chunkId] + ".chunk.js";
};